import { buildBehavior } from "./behavior";
export const Circular = buildBehavior({
    properties: () => ({
        radius: 10,
    }),
});
